// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_lamp_021_surface/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_lamp_021_surface: ModuleSchema = {
  "id": "core_lamp_021_surface",
  "uniqueId": "B3D_L021S",
  "createdAt": "2026-10-12T00:00:00Z",
  "updatedAt": "2026-10-13T01:31:13.651Z",
  "label": "Ripple",
  "description": "Distinctive fluted outer shell, sized at 85 mm diameter by 70 mm height and designed to pair with an E27 base.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_L021_SURFACE"
  ],
  "sliders": [
    {
      "key": "baseDia",
      "label": "Surface Diameter",
      "min": 40,
      "max": 180,
      "step": 1,
      "default": 85,
      "unit": "mm"
    },
    {
      "key": "baseHeight",
      "label": "Surface Height",
      "min": 5,
      "max": 200,
      "step": 1,
      "default": 70,
      "unit": "mm"
    },
    {
      "key": "fluteCount",
      "label": "Flute Count",
      "min": 3,
      "max": 160,
      "step": 1,
      "default": 40,
      "unit": "flutes"
    },
    {
      "key": "fluteDepth",
      "label": "Flute Depth",
      "min": 0,
      "max": 10,
      "step": 0.1,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "segments",
      "label": "Circular Resolution",
      "min": 32,
      "max": 256,
      "step": 16,
      "default": 160,
      "unit": "segments"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "lamp_021_surface",
      "label": "Ripple Body",
      "default": "#64748b"
    }
  ],
  "objects": [],
  "exportGroups": []
};
